import React from 'react';
import {Trans} from 'react-i18next';

export default function ChooseUITemplate({
  isDefaultLayout,
  setIsDefaultLayout,
}) {
  return (
    <div>
      <label className="kt-padding-r-10">
        <input
          type="radio"
          value={true}
          checked={isDefaultLayout}
          onChange={() => {
            setIsDefaultLayout(true);
          }}
        />
        &nbsp;
        <Trans i18nKey="p.s.uiconfiguration.generic.ui">
          Use Generic UI Configurations
        </Trans>
      </label>
      <label className="kt-padding-r-10">
        <input
          type="radio"
          value={false}
          checked={!isDefaultLayout}
          onChange={() => {
            setIsDefaultLayout(false);
          }}
        />
        &nbsp;
        <Trans i18nKey="p.s.uiconfiguration.customized.ui">
          Use Customized UI
        </Trans>
      </label>
    </div>
  );
}
